// extracted by mini-css-extract-plugin
export default {"FbButton":"FacebookLogin_FbButton__h4Spj","Disabled":"FacebookLogin_Disabled__nGCY3"};